// extracted by mini-css-extract-plugin
module.exports = {"SupportPolicyMobile":"SupportPolicy_SupportPolicyMobile__DuZBc"};